export const CONTAINER_SELECTORS = {
    TABLE: '.ant-table-content',
};

export const SCROLL_HEIGHT_THRESHOLD = 900;
